/**
 * RX control scale - jedna vyskova skala pre vsetky inline ovladace v hero riadku:
 * nav pilulky (Ponuka / Dopyt / Realitne kancelarie), bare fieldy klasickeho
 * filtra a kruhove ikonove tlacidla vedla nich.
 *
 * PRECO TOTO EXISTUJE:
 * Pilulka mala vysku fluidnu (py-[9px] + line-height fontu) -> 36 / 37,5 / 39 px
 * podla breakpointu, field mal natvrdo 32 / 34 / 38 px na inych breakpointoch.
 * Nikdy sa nestretli. Vyska teraz nezavisi od fontu ani od line-height.
 *
 * HARD RULE: ziadny ovladac v tomto riadku si nedefinuje vlastnu vysku.
 * Vzdy RX_CONTROL_H (obdlznikove) alebo RX_CONTROL_SQ (kruhove/stvorcove).
 *
 * Pozn.: solidne tlacidla (Button.tsx) na tuto skalu NEPATRIA - ziju na bielych
 * plochach a maju vlastnu, vacsiu skalu (40 / 45 px).
 */

/** Vyska ovladaca. Vzdy spolu s flex + items-center (padding uz vysku neurcuje). */
export const RX_CONTROL_H = 'h-[36px] sm:h-[38px] xl:h-[40px]';

/** Kruhovy / stvorcovy ovladac v rovnakom riadku - rovnaka vyska aj sirka. */
export const RX_CONTROL_SQ =
    'size-[36px] min-w-[36px] sm:size-[38px] sm:min-w-[38px] xl:size-[40px] xl:min-w-[40px]';
